export default __webpack_public_path__ + "static/petiteMaro.cover-d6d5fb579fd7d83fc47baede03a6f018.jpg";